import { Loader } from '../../components/Loader';
import { useAddressForm } from '../../hooks/address-form.hook';
import { testId } from '../../utils';
import { AddAddress } from './add-address';
import { ExistingAddress } from './existing-address';
import { Cornerstone } from '@rpi/api';
import React from 'react';

export interface CheckoutAddressStepProps {
  'data-testid': string;
  selectedAddress?: Cornerstone.ValueAddress;
  noDefault?: boolean;
  onContinue?: (address: Cornerstone.ValueAddress) => void;
  onSelect?: (address: Cornerstone.ValueAddress) => void;
  addAddressForm: ReturnType<typeof useAddressForm>;
  editAddressForm: ReturnType<typeof useAddressForm>;
  onAdd?: () => void;
  onEdit?: () => void;
  checkoutLoading?: boolean;
}

export const CheckoutAddress: React.FC<CheckoutAddressStepProps> = ({
  'data-testid': dataTestId,
  noDefault,
  selectedAddress,
  onContinue,
  onSelect,
  addAddressForm,
  editAddressForm,
  onAdd,
  onEdit,
  checkoutLoading = false,
}) => {
  const [addingAddress, setAddingAddress] = React.useState(false);
  const {
    data: addressesResponse,
    isLoading,
    error,
  } = Cornerstone.useGetUserAddresses();

  const onAddNewAddress = React.useCallback(() => {
    onAdd?.();
    setAddingAddress(true);
  }, [onAdd]);

  const onCancelAdding = React.useCallback(() => {
    setAddingAddress(false);
  }, []);

  if (isLoading || !addressesResponse) {
    return <Loader size="md" />;
  }
  const addressList = addressesResponse.data.additional?.length;

  if (
    addingAddress ||
    (!addressesResponse.data.defaultShipping && addressList === 0)
  ) {
    return (
      <AddAddress
        {...testId(dataTestId)}
        onContinue={onContinue}
        onCancel={onCancelAdding}
        noDefault={noDefault}
        addressForm={addAddressForm}
        checkoutLoading={checkoutLoading}
        hideCancel={addressList === 0}
      />
    );
  }

  if (error) {
    return 'Error getting addresses';
  }

  return (
    <ExistingAddress
      {...testId(dataTestId)}
      noDefault={noDefault}
      address={selectedAddress}
      addressBook={addressesResponse.data}
      onContinue={onContinue}
      onAddNewAddress={onAddNewAddress}
      onSelect={onSelect}
      addressForm={editAddressForm}
      onEdit={onEdit}
      checkoutLoading={checkoutLoading}
    />
  );
};
